import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router,useLocation } from "react-router-dom";
import AnimatedRoutes from '@/Components/AnimatedRoutes';
import Header from '@/Components/Header';
import MessageCarousel from "../Components/MessagePopup";
import server2 from '@/services';

const Routers = () => {
    let [ headerStyle, updateHeaderStyle ] = useState(undefined);

    const [showCarousel, setShowCarousel] = useState(false);
    const [hasSeenPopup, setHasSeenPopup] = useState(false);
    let [ carouselMessages, updateCarouselMessages ] = useState({});

    useEffect(async () => {
        // 获取本地访问地址路径
        // const seen = localStorage.getItem('hasSeenWelcomePopup') === 'true';
        // setHasSeenPopup(seen);

        // 如果没看过，则显示弹窗
        setShowCarousel(true);
        // if (!seen) {
        //
        // }
        const fetchMessages = async () => {
            try {
                let list = await server2.MessagePopup.messagePopup();
                updateCarouselMessages(list.data.data);
            } catch (error) {
                console.error("获取轮播消息失败:", error);
            }
        };

        fetchMessages();
    }, []);

    const handleCloseCarousel = () => {
        // 记录用户已看过弹窗
        // localStorage.setItem('hasSeenWelcomePopup', 'true');
        setHasSeenPopup(true);
        setShowCarousel(false);
    };

     /*carouselMessages = [
        { title: '关于强烈谴责不法分子冒用我公司名义实施诈骗行为的声明',
            content: '近期，本公司接到相关举报，有疑似名为邹某林、翟某强、关某亚、明某等人恶意冒用本公司高管和员工及委托人等名义开' +
                '展募资、投资、委托等业务，企图利用本公司名称、社会知名度诱骗广大社会公众。并以本公司名义，用伪造的印章与有关单位签' +
                '订各类协议。对此，本公司高度重视，为保障社会公众合法权益，维护招商资本声誉，特此郑重声明：\n' +
                '1邹某林、翟某强、关某亚、明某等人非本公司人员，本公司未授权其开展任何业务活动。\n' +
                '2.邹某林、翟某强、关某亚、明某等人应立刻停止相关侵权及违法犯罪行为，我公司保留依法追究相关法律责任的权利。\n' +
                '3如发现任何市场主体或个人假冒我司名义对外洽谈业务、承揽合作、签署合同等，欢迎广大公众与我司联系举报并提供线\n' +
                '索。近期，本公司接到相关举报，有疑似名为邹某林、翟某强、关某亚、明某等人恶意冒用本公司高管和员工及委托人等名义开' +
                '展募资、投资、委托等业务，企图利用本公司名称、社会知名度诱骗广大社会公众。并以本公司名义，用伪造的印章与有关单位签' +
                '订各类协议。对此，本公司高度重视，为保障社会公众合法权益，维护招商资本声誉，特此郑重声明：\n' +
                '1邹某林、翟某强、关某亚、明某等人非本公司人员，本公司未授权其开展任何业务活动。\n' +
                '2.邹某林、翟某强、关某亚、明某等人应立刻停止相关侵权及违法犯罪行为，我公司保留依法追究相关法律责任的权利。\n' +
                '3如发现任何市场主体或个人假冒我司名义对外洽谈业务、承揽合作、签署合同等，欢迎广大公众与我司联系举报并提供线近期，本公司接到相关举报，有疑似名为邹某林、翟某强、关某亚、明某等人恶意冒用本公司高管和员工及委托人等名义开' +
                '展募资、投资、委托等业务，企图利用本公司名称、社会知名度诱骗广大社会公众。并以本公司名义，用伪造的印章与有关单位签' +
                '订各类协议。对此，本公司高度重视，为保障社会公众合法权益，维护招商资本声誉，特此郑重声明：\n' +
                '1邹某林、翟某强、关某亚、明某等人非本公司人员，本公司未授权其开展任何业务活动。\n' +
                '2.邹某林、翟某强、关某亚、明某等人应立刻停止相关侵权及违法犯罪行为，我公司保留依法追究相关法律责任的权利。\n' +
                '3如发现任何市场主体或个人假冒我司名义对外洽谈业务、承揽合作、签署合同等，欢迎广大公众与我司联系举报并提供线近期，本公司接到相关举报，有疑似名为邹某林、翟某强、关某亚、明某等人恶意冒用本公司高管和员工及委托人等名义开' +
                '展募资、投资、委托等业务，企图利用本公司名称、社会知名度诱骗广大社会公众。并以本公司名义，用伪造的印章与有关单位签' +
                '订各类协议。对此，本公司高度重视，为保障社会公众合法权益，维护招商资本声誉，特此郑重声明：\n' +
                '1邹某林、翟某强、关某亚、明某等人非本公司人员，本公司未授权其开展任何业务活动。\n' +
                '2.邹某林、翟某强、关某亚、明某等人应立刻停止相关侵权及违法犯罪行为，我公司保留依法追究相关法律责任的权利。\n' +
                '3如发现任何市场主体或个人假冒我司名义对外洽谈业务、承揽合作、签署合同等，欢迎广大公众与我司联系举报并提供线\n' +
                '4.恳请广大公众提高警惕、谨防受骗。' },
        { title: '新功能上线', content: '辽宁兴辽招金新时代股权基金总规模约50亿元，基金将广泛汇集辽宁省内外资' +
                '源，以对外投资子基金为主，兼顾部分项目直投。基金围绕辽宁省4个万亿级产业基地' +
                '建设开展投资运营，服务于辽宁省数控机床、航空装备、船舶与海工装备、轨道交通、' +
                '菱镁精深加工、电力装备、压缩机和制冷装备、精细化工、高品质钢铁材料、先进有色' +
                '金属、粮油、畜禽、集成电路、节能环保、新能源汽车、生物医药、人工智能、软件、' +
                '工业互联网、机器人及无人机、先进医疗装备、氢能等22条产业赛道。为确保辽宁兴辽' +
                '招金新时代股权基金投资业务规范运行，提高托管银行服务质量，现公开遴选基金托管' +
                '银行：' },
        { title: '更新提醒', content: '请确保您的应用是最新版本以获取最佳体验' }
    ];*/

    return (
        <Router>
            {/* 条件渲染弹窗 */}
            {showCarousel && (
                <MessageCarousel
                    carouselMessages={carouselMessages}
                    onClose={handleCloseCarousel}
                />
            )}
            <Header headerStyle={headerStyle} />

            <AnimatedRoutes updateHeaderStyle={updateHeaderStyle} />

        </Router>



    );
};

export default Routers;
